import styled, { css } from 'styled-components';

import { Text } from '../../../../components';
import { Affix as FieldAffix } from '../../../../components/Field/Field.styles';
import { Hint as TextAreaHint } from '../../../../components/TextArea/TextArea.styles';
import { COLORS, SPACE } from '../../../../theme/tokens';

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${SPACE[12]};
  flex-wrap: wrap;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[20]};
`;

/** One field with its tags, notes and error; `$warn` turns its counter to the warning tone. */
export const FieldBlock = styled.div<{ $warn: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};

  ${(p) =>
    p.$warn &&
    css`
      ${FieldAffix}, ${TextAreaHint} {
        color: ${COLORS.warning};
      }
    `}
`;

export const TagRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  flex-wrap: wrap;
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const HintText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.warning};
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;

export const Preview = styled.figure`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  margin: 0;
  padding: ${SPACE[16]};
  border-radius: 12px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${COLORS.surfaceInset};
  min-width: 0;
`;

export const PreviewLabel = styled(Text)`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${COLORS.textFaint};
`;

export const PreviewUrl = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
  word-break: break-all;
`;

export const PreviewTitle = styled(Text)`
  font-size: 18px;
  color: ${COLORS.accent};
  overflow-wrap: anywhere;
`;

export const PreviewDescription = styled(Text)`
  font-size: 13px;
  line-height: 1.5;
  color: ${COLORS.text};
  overflow-wrap: anywhere;
`;

export const PreviewEmpty = styled(Text)`
  font-size: 13px;
  color: ${COLORS.textFaint};
`;
